import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconChevronCompactRight = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.649 3.064a1 1 0 0 1 1.287.585l3 8a1 1 0 0 1 0 .702l-3 8a1 1 0 1 1-1.872-.702L12.932 12l-2.868-7.649a1 1 0 0 1 .585-1.287"
            clipRule="evenodd"
        />
    </svg>
);
